export const adminWebAplicationUrl = process.env.REACT_APP_WEB_ADMIN;
export const webUserPortalAplicationUrl = process.env.REACT_APP_WEB_USER_PORTAL;
export const authRoute = `/auth`;

export const dashboard = (): string => "/dashboard";

export const institutions = (): string => "/institutions";

export const components = (): string => "/components";

export const aboutProgramRoute = (): string => "/aboutprogram";
export const izjavaOPristupacnostiRoute = (): string =>
  "/izjava-o-pristupacnosti";

export const newRequestUrl = (childOib: string): string =>
  `/requests/new?childOib=${childOib}`;

export const newRequestRoute = (): string => "/requests/new";

export const editRequestUrl = (requestId: number): string =>
  `/requests/${requestId}/edit`;

export const editRequestAsAdminUrl = (
  requestId: number,
  applicantParentOib: string
): string =>
  `/requests/${requestId}/edit?applicantParentOib=${applicantParentOib}`;

export const editRequestRoute = (): string => "/requests/:requestId/edit";

export const draftRequestUrl = (guid: string): string =>
  `/requests/drafts/${guid}/edit`;

export const draftRequestAsAdminUrl = (
  guid: string,
  applicantParentOib: string
): string =>
  `/requests/drafts/${guid}/edit?applicantParentOib=${applicantParentOib}`;

export const draftRequestRoute = (): string => `/requests/drafts/:guid/edit`;

export const requestDetailsUrl = (requestId: number): string =>
  `/requests/${requestId}/details`;

export const requestDetailsRoute = (): string => "/requests/:reqId";

export const requestDraftDetailsUrl = (guid: string): string =>
  `/requests/drafts/${guid}/details`;

export const requestDraftDetailsRoute = (): string => "/requests/drafts/:guid";

export const institutionLocationsAndProgramsRoute = (): string =>
  "/institutions/:pedagogicalYearInstitutionId";

export const institutionLocationsAndProgramsUrl = (
  pedagogicalYearInstitutionId: number
): string => `/institutions/${pedagogicalYearInstitutionId}/locations-programs`;

export const adminRequestsUrl = (): string =>
  `${adminWebAplicationUrl}/requests`;

export const adminSubsequentRequestsUrl = (): string =>
  `${adminWebAplicationUrl}/subsequentRequests`;

export const newPreschoolRequestUrl = (childOib: string): string =>
  `/preschoolRequests/new?childOib=${childOib}`;

export const newPreschoolRequestRoute = (): string => "/preschoolRequests/new";

export const editPreschoolRequestUrl = (requestId: number): string =>
  `/preschoolRequests/${requestId}/edit`;

export const editPreschoolRequestAsAdminUrl = (
  requestId: number,
  applicantParentOib: string
): string =>
  `/preschoolRequests/${requestId}/edit?applicantParentOib=${applicantParentOib}`;

export const editPreschoolRequestRoute = (): string =>
  "/preschoolRequests/:requestId/edit";

export const draftPreschoolRequestUrl = (guid: string): string =>
  `/preschoolRequests/drafts/${guid}/edit`;

export const draftPreschoolRequestAsAdminUrl = (
  guid: string,
  applicantParentOib: string
): string =>
  `/preschoolRequests/drafts/${guid}/edit?applicantParentOib=${applicantParentOib}`;

export const draftPreschoolRequestRoute = (): string =>
  `/preschoolRequests/drafts/:guid/edit`;

export const preschoolRequestDetailsUrl = (requestId: number): string =>
  `/preschoolRequests/${requestId}/details`;

export const preschoolRequestDetailsRoute = (): string =>
  "/preschoolRequests/:reqId";

export const preschoolRequestDraftDetailsUrl = (guid: string): string =>
  `/preschoolRequests/drafts/${guid}/details`;

export const preschoolRequestDraftDetailsRoute = (): string =>
  "/preschoolRequests/drafts/:guid";

export const adminPreschoolRequestsUrl = (): string =>
  `${adminWebAplicationUrl}/preschoolRequests`;

export const newErrorReporRoute = (): string => "/errorReport/new";
